import { useQuery } from "@tanstack/react-query"
import { useState } from "react"
import { useCombinedImageUrlsFromSearchParams } from "./use-combined-image-urls-from-search-params"

export function useCombinedImageImages() {
  const { urls: urlsToLoad } = useCombinedImageUrlsFromSearchParams()
  const [urls, setUrls] = useState([])
  const query = useQuery({
    queryKey: ["combined-image", ...urlsToLoad],
    queryFn: () => preloadImages(urlsToLoad),
    onSuccess(data) {
      // This is to make sure, the 'old' urls are still shown while the new one is loading
      setUrls(data)
    },
  })

  return {
    status: query.status,
    refetch: query.refetch,
    urls,
  }
}
async function preloadImages(urls: string[]) {
  const promises = urls.map((url) => {
    return fetch(url)
      .then(async (response) => {
        if (response.status !== 200) {
          throw new Error(response.statusText)
        }
      })
      .then(() => url)
  })
  const result = await Promise.all(promises)
  return result
}
